import { masterApiUrl } from "API/urls/master.api";
import { axiosInstance } from "configs/axios";

export const fetchCurrentProjectProductsApi = async (projectId) => {
  try {
    const response = await axiosInstance.post(
      masterApiUrl.getProductVariantParent,
      {
        projectId,
      }
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
